import { useEffect } from 'react';
import { Metrics } from '../../metrics';
export function useTelemetry(componentName) {
    useEffect(function () {
        if (typeof window !== 'undefined') {
            Metrics.sendMetricOnce('awsui-viewport-width', window.innerWidth || 0);
            Metrics.sendMetricOnce('awsui-viewport-height', window.innerHeight || 0);
        }
        Metrics.logComponentLoaded();
        Metrics.logComponentUsed(componentName.toLowerCase());
        // Components do not change the name dynamically. Explicit empty array to prevent accidential double metrics
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
//# sourceMappingURL=index.js.map